import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/it';
moment.locale('fr');
export default (function (ctx, inject) {
  ctx.$moment = moment;
  inject('moment', moment);
});